import { Component, DestroyRef, EventEmitter, inject, Output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { Button } from 'primeng/button';
import { Menu } from 'primeng/menu';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../Services/auth.service';
import { HeaderService } from '../../Services/header.service';
import { LoaderService } from '../../Services/loader.service';
import { LoaderComponent } from '../loader/loader';

@Component({
  selector: 'app-header',
  imports: [Menu, Button, AvatarModule, LoaderComponent],
  templateUrl: './header.html',
})
export class Header {
  @Output() toggleSidebar = new EventEmitter<void>();
  private authService = inject(AuthService);
  private router = inject(Router);
  protected headerService = inject(HeaderService);
  private destroyRef = inject(DestroyRef);
  private loaderService = inject(LoaderService);

  // Define the menu items
  readonly userMenuItems = signal<MenuItem[]>([
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      iconClass: '!text-red-500 dark:!text-red-400',
      linkClass: '!text-red-500 dark:!text-red-400',
      command: () => this.logout(),
    },
  ]);

  logout() {
    this.loaderService.show('header-loader');
    this.authService.logout();
    this.router.navigate(['/login']);
    this.loaderService.hide('header-loader');
  }
}
